module.exports = __webpack_public_path__ + "img/item4-3.cc1843c2.jpg";